export const CATEGORIES_RETRIEVE_REQUEST = 'CATEGORIES_RETRIEVE_REQUEST';
export const CATEGORIES_RETRIEVE_SUCCESS = 'CATEGORIES_RETRIEVE_SUCCESS';
export const CATEGORIES_RETRIEVE_FAILURE = 'CATEGORIES_RETRIEVE_FAILURE';
export const CATEGORIES_CANCEL_ALL_REQUESTS = 'CATEGORIES_CANCEL_ALL_REQUESTS';

export const CATEGORIES_CREATE_REQUEST = 'CATEGORIES_CREATE_REQUEST';
export const CATEGORIES_CREATE_SUCCESS = 'CATEGORIES_CREATE_SUCCESS';
export const CATEGORIES_CREATE_FAILURE = 'CATEGORIES_CREATE_FAILURE';

export const CATEGORIES_EDIT_REQUEST = 'CATEGORIES_EDIT_REQUEST';
export const CATEGORIES_EDIT_SUCCESS = 'CATEGORIES_EDIT_SUCCESS';
export const CATEGORIES_EDIT_FAILURE = 'CATEGORIES_EDIT_FAILURE';

export const CATEGORIES_DELETE_REQUEST = 'CATEGORIES_DELETE_REQUEST';
export const CATEGORIES_DELETE_SUCCESS = 'CATEGORIES_DELETE_SUCCESS';
export const CATEGORIES_DELETE_FAILURE = 'CATEGORIES_DELETE_FAILURE';

export const CATEGORY_COLLAPSE = 'CATEGORY_COLLAPSE';
export const CATEGORIES_LIST_CLEAR = 'CATEGORIES_LIST_CLEAR';
export const COLLECTION_COLLAPSE_TOGGLE = 'COLLECTION_COLLAPSE_TOGGLE';
export const CATEGORIES_NUMBER_INDICATOR_UPDATE = 'CATEGORIES_NUMBER_INDICATOR_UPDATE';

export const CATEGORIES_PURGE_RECYCLEBIN_REQUEST = 'CATEGORIES_PURGE_RECYCLEBIN_REQUEST';
export const CATEGORIES_PURGE_RECYCLEBIN_SUCCESS = 'CATEGORIES_PURGE_RECYCLEBIN_SUCCESS';
export const CATEGORIES_PURGE_RECYCLEBIN_FAILURE = 'CATEGORIES_PURGE_RECYCLEBIN_FAILURE';
